// Die Handballen-Sperre beim Zeichnen (seit 19.10.2026): Manuel zeichnet
// gern mit dem Stift (Surface, vielleicht iPad) und legt dabei die Hand aufs
// Glas. Pointer Events melden Stift und Finger gleich – nur `pointerType`
// sagt, was es ist. Die Regel: Sobald auf diesem Zeichenbildschirm einmal
// ein Stift („pen“) zeichnete, zählen Berührungen mit dem Finger („touch“)
// nicht mehr – bis der Bildschirm verlassen wird. Wer nur mit dem Finger
// zeichnet (iPhone), merkt nichts davon; die Maus zählt immer. Druck und
// Neigung des Stifts nimmt die App bewusst nicht (PLAN: keine Druckstärke).

export class Handballensperre {
  private stiftGesehen = false;

  /** Darf dieser Zeiger zeichnen? Merkt sich dabei, ob schon ein Stift da war. */
  zaehlt(zeigerArt: string): boolean {
    if (zeigerArt === "pen") this.stiftGesehen = true;
    return !(this.stiftGesehen && zeigerArt === "touch");
  }

  /** Kam auf diesem Bildschirm schon ein Stift? */
  get stift(): boolean {
    return this.stiftGesehen;
  }
}
